import { createRouter, createWebHistory } from 'vue-router';
import Home from '../components/HalamanHome.vue';
import About from '../components/HalamanAbout.vue';
import Pimpinan from '../components/HalamanGaleri.vue';
import Dai from '../components/HalamanDai.vue';
import Komisi from '@/components/HalamanTabelKomisi.vue';
import Struktur from '@/components/HalamanTabelStruktur.vue';
import HalamanBerita from '@/components/HalamanBerita.vue';
import HalamanFatwa from '@/components/HalamanFatwa.vue';
import HalamanKhutbah from '@/components/HalamanKhutbah.vue';
import HalamanDetailKhutbah from '@/components/HalamanDetailKhutbah.vue';
import HalamanDetailBerita from '@/components/HalamanDetailBerita.vue';

const routes = [
  { path: '/', component: Home },
  { path: '/home', component: Home },
  { path: '/about', component: About },
  { path: '/pimpinan', component: Pimpinan },
  { path: '/dai', component: Dai },
  { path: '/komisi', component: Komisi },
  { path: '/struktur', component: Struktur },
  { path: '/berita', component: HalamanBerita },
  { path: '/fatwa', component: HalamanFatwa },
  { path: '/khutbah', component: HalamanKhutbah },
  {
    path: '/khutbah/:id',
    name: 'KhutbahDetail',
    component: HalamanDetailKhutbah,
    props: true, // Untuk meneruskan parameter `id` sebagai props
  },
  {
    path: '/berita/:id',
    name: 'BeritaDetail',
    component: HalamanDetailBerita,
    props: true, // Untuk meneruskan parameter `id` sebagai props
  },
  
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
});

export default router;
